export default "__VITE_ASSET__CRgTYBjW__$_?no-inline__"